import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ServicePackagesPositionsEditor.html?raw';
import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import NumberInput from '../../../../moreCore/UI/NumberInput/NumberInput';


class ServicePackagesPositionsEditor extends compose(_StatefulSection) {
    templateString: any = template;

    input_QuantityMultiplier: MdsLax<InstanceType<typeof NumberInput>>;
    input_Quantity: MdsLax<InstanceType<typeof NumberInput>>;

    afterSetData() {
        let data = this.sourceData;

        let unit = this.getAttributeValue("service_unit");
        if (unit) this.input_Quantity.setUnit(unit);
    }

    onDirtyChange(currentState: boolean) {

    }

    _onChanged(key: string, value: any) {

        this.emit("ServicePackagesPositions_ChacgedData", this.changedData)
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ServicePackagesPositionsEditor);
